export default "__VITE_ASSET__CjI6vUt___"